import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../../services/notification.service';
import { BehaviorSubject } from 'rxjs';
import { FieldmagicDropdownOption } from '../../../../../../shared/components/forms/input/dropdown/dropdown.component';
import { arr_map, data_get, fallback } from '../../../../../../shared/utils/common';
import { translate_period } from '../../../../../../module/checklists';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-choose-inspection-period',
  templateUrl: './choose-inspection-period.component.html',
  styleUrls: ['./choose-inspection-period.component.scss']
})
export class ChooseInspectionPeriodComponent implements OnInit {
  form: FormGroup;

  readonly periods$ = new BehaviorSubject<FieldmagicDropdownOption<{id: string}>[]>([]);

  constructor(
    public dialogRef: MatDialogRef<ChooseInspectionPeriodComponent>,
    private notifService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private readonly _translator: TranslateService,
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      checklist_name: new FormControl(this.dialogData.text),
      choose_period: new FormControl([], Validators.required),
    });

    const periods = fallback(data_get(this.dialogData, 'available_periods'), {
      fallback: () => [],
    });

    this.periods$.next(arr_map(periods, {
      transformer: (value) => ({
        id: value,
        text: translate_period(value, {
          translator: this._translator,
        }),
      }),
    }));
  }

  /**
   * Closes the dialog
   *
   * @returns {void}
   */
  dialogClose(): void {
    this.dialogRef.close({
      success: false,
      data: {
        id: this.dialogData.id
      }
    });
  }

  submit(): void {
    this.form.get('choose_period').markAsDirty();
    this.form.get('choose_period').markAsTouched();

    if (this.form.invalid) {
      this.notifService.notifyError('please_complete_the_form');
    } else {
      const periods = fallback(this.form.get('choose_period').value, {
        fallback: () => [],
      });

      this.notifService.notifySuccess('inspection_period_chosen');
      this.dialogRef.close({
        success: true,
        data: {
          id: this.dialogData.id,
          periods: arr_map(periods, {
            transformer: (period) => data_get(period, 'id'),
          }),
        },
      });
    }
  }
}
